import Typography from '@mui/material/Typography';

const formatTime = (seconds: number): string => {
  if (seconds < 0 || !Number.isFinite(seconds)) {
    return '0:00';
  }

  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);

  return `${m}:${s.toString().padStart(2, '0')}`;
};

type TimeDisplayProps = {
  currentTime: number;
  duration: number;
};

export function TimeDisplay({ currentTime, duration }: TimeDisplayProps) {
  return (
    <Typography variant="caption" sx={{ whiteSpace: 'nowrap', color: theme => theme.palette.common.white }}>
      {formatTime(currentTime)} / {formatTime(duration)}
    </Typography>
  );
}
